/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.15.0
 * @since 1.15.0
 */

import { AccessComponentKeyEnum } from '../../../modules/role/constants/guard/guardConstants';
import { guardComponentType } from '../../../modules/role/reducer/guardReducer';
import { ExternalRoutePath } from '../../../routes/constants/externalRoutes';
import { ROUTE_INQUIRY_ID, RoutePath } from '../../../routes/constants/routesConstants';

export const getPageInquiryInfoUrl = (guardTypes: guardComponentType, id: string, branch?: string) =>
    guardTypes[AccessComponentKeyEnum.PageInquiryInfo]
        ? RoutePath.inquiryInfo.replace(ROUTE_INQUIRY_ID, id)
        : `${ExternalRoutePath.inquiry}/${id}${branch ? `?branch=${branch}` : ''}`;

export const getPageInquiryInfoUrlRegex = (guardTypes: guardComponentType) =>
    guardTypes[AccessComponentKeyEnum.PageInquiryInfo]
        ? RoutePath.inquiryInfo
        : ExternalRoutePath.inquiry;

export const isPageInquiryInfoExternalUrl = (guardTypes: guardComponentType) =>
    !guardTypes[AccessComponentKeyEnum.PageInquiryInfo];

